//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableServer from '../../../../components/Table/Table.vue'
import TableCellExpand from '../../../../components/Table/TableCellExpand.vue'
import StockToolPartyInfo from '../../../../forms/StockTools/StockToolPartyInfo.vue'
import { formatTrueFalse } from '../../../../components/helpers.js'
import { EventBus } from '../../../../EventBus/EventBus.js'

function formatAmount (value) {
  if (value) {
    return Math.floor(value * 1000) / 1000
  } else {
    return value
  }
}

export default {
  name: 'StocksDebitsTab',
  components: {
    TableServer,
    TableCellExpand
  },
  props: {
    stockId: {
      type: Number,
      default: null
    },
    formId: {
      type: String,
      default: null
    }
  },
  data: function () {
    return {
      filterType: 'stockDebits',
      correction: null,

      startDate: null,
      pagination: {
        rowsPerPage: 0,
        page: 1
      },
      toolTransfersColumns: [
        {
          name: 'transferDate',
          label: 'Дата/время',
          align: 'left',
          field: 'transferDate',
          sortable: true
        },
        {
          name: 'transferAmount',
          label: 'Кол-во',
          align: 'left',
          field: 'transferAmount',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          sortable: true
        },
        {
          name: 'document',
          label: 'Документ',
          align: 'left',
          field: 'document',
          sortable: true
        }
      ],
      columns: this.getColumns(),
      loading: false
    }
  },
  computed: {
    additionalUrlParams: function () {
      if (this.stockId) {
        return {
          stockId: this.stockId
        }
      }
      return null
    },
    exportOptions: function () {
      if (this.stockId) {
        return [{
          label: 'Выгрузить в Excel',
          includeFilter: true,
          props: {
            stockId: this.stockId
          }
        }]
      }
      return undefined
    },
    visibleColumns: function () {
      let columns = this.columns || []
      if (this.correction != null) {
        if (this.correction) {
          columns = columns.filter(column => column.correction !== false)
        } else {
          columns = columns.filter(column => column.correction !== true)
        }
      }
      return columns.map(column => column.name)
    }
  },
  methods: {
    onUpdate: function () {
      const tableComponent = this.$refs.table
      if (tableComponent) {
        tableComponent.onUpdate()
      }
    },
    onTableItemsUpdated: function (event) {
      const additionalData = event.additionalData
      if (additionalData) {
        const correction = additionalData.correction != null ? additionalData.correction : null
        if (correction !== this.correction) {
          this.correction = correction
          this.updateColumns()
        }
        if (additionalData.filterUpdated) {
          EventBus.$emit('update-server-filter', {
            type: this.filterType
          })
        }
      }
    },

    onOpenReport: function (url) {
      window.open(url, '_blank')
    },

    onClickRow: function (col, row) {
      if (col.name === 'isParty' && row.isParty) {
        const dialog = this.$d.dialog(this).show({
          headerLabel: `${row.tlName}`,
          contentComponent: StockToolPartyInfo,
          maximized: true,
          contentProps: {
            toolKey: row.tlKey,
            stockKey: row.stockKey,
            correction: this.correction,
            unit: row.unit
          }
        })
      }
    },

    updateColumns: function () {
      this.columns = this.getColumns()
    },
    getColumns: function () {
      return this.prepareColumns([{
        name: 'stockName',
        label: 'Склад',
        sortable: true
      },
      {
        name: 'stockType',
        label: 'Тип склада',
        sortable: true
      },
      {
        name: 'brName',
        label: 'Текущая бригада',
        sortable: true,
        correction: false
      },
      {
        name: 'vhlName',
        label: 'Транспортное средство',
        sortable: true,
        correction: false
      },
      {
        name: 'tlName',
        label: 'Материал',
        alwaysActive: true,
        sortable: true
      },
      {
        name: 'type',
        label: 'Тип номенклатуры',
        sortable: true
      },
      {
        name: 'vid',
        label: 'Вид номенклатуры',
        sortable: true
      },
      {
        name: 'tlKey',
        label: 'ID номенклатурной позиции в 1С',
        sortable: true
      },
      {
        name: 'nomAffilation',
        label: 'Принадлежность номенклатуры',
        sortable: true
      },
      {
        name: 'isParty',
        label: 'Партии',
        format: formatTrueFalse,
        alwaysActive: true,
        sortable: true
      },
      {
        name: 'partiesCount',
        label: 'Кол-во партий',
        sortable: true
      },
      {
        name: 'unit',
        label: 'Ед. измерения',
        sortable: true
      },
      {
        name: 'amount',
        label: 'Остаток (1С)',
        sortable: true,
        format: formatAmount,
        correction: false
      },
      {
        name: 'shortfall',
        label: 'Недостача (1С)',
        sortable: true,
        format: formatAmount,
        correction: true
      },
      {
        name: 'excess',
        label: 'Излишек (1С)',
        sortable: true,
        format: formatAmount,
        correction: true
      },
      {
        name: 'reservedAmount',
        label: 'Зарезервировано (Д2)',
        sortable: true,
        format: formatAmount,
        correction: false
      },
      {
        name: 'notReservedAmount',
        label: 'Свободно (Д2)',
        field: (row) => (row.amount - row.reservedAmount) > 0 ? (row.amount - row.reservedAmount) : 0,
        sortable: true,
        format: formatAmount,
        correction: false
      },
      {
        name: 'd2Out',
        label: 'Списания Д2 (за отчетный период)',
        sortable: true,
        correction: false
      },
      {
        name: 'd2RepsData',
        label: 'Отчеты Д2 (за отчетный период)',
        sortable: true,
        correction: false
      },
      {
        name: 'toolObjects',
        label: 'Разбивка по объектам',
        sortable: true,
        correction: false
      },
      {
        name: 'controlled',
        label: 'Контроль наличия',
        defaultWidth: 80,
        format: formatTrueFalse,
        sortable: false,
        correction: false
      },
      {
        name: 'controllingDepartments',
        label: 'Контролирующие отделы',
        format: val => val && val.length ? val.map(item => item.name).join(', ') : null,
        sortable: false,
        correction: false
      }])
    },
    prepareColumns: function (columns) {
      for (const column of columns) {
        if (!column.field) {
          column.field = column.name
        }
        if (!column.align) {
          column.align = 'left'
        }
      }
      if (this.stockId != null) {
        const multipleStocksColumns = new Set(['stockName', 'stockType', 'brName', 'vhlName'])
        columns = columns.filter(column => !multipleStocksColumns.has(column.name))
      }
      return columns
    },

    getTdClass: function (col, row) {
      if (col.name === 'isParty' && row.isParty) {
        return 'bg-accent text-white cursor-pointer'
      }
    }
  }
}

